import axios from 'axios';

// Base URL for the backend API — change this to your actual backend URL
const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.manthuliorangics.in/api';
// const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

const axiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 10000,
});

// ─── Request Interceptor ──────────────────────────────────────────────────────
// Attach the JWT token from localStorage to every outgoing request
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('adminToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// ─── Response Interceptor ─────────────────────────────────────────────────────
// Only auto-logout/reload on 401 when a token already exists (expired session).
// Do NOT reload on 401 during a login attempt — that would clear the error message.
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        const isExpiredSession =
            error.response?.status === 401 &&
            !!localStorage.getItem('adminToken');          // already logged in → session expired

        if (isExpiredSession) {
            localStorage.removeItem('adminToken');
            localStorage.removeItem('adminUser');
            window.location.reload();
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
